import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hiddenLoader } from "../../stores/loading";
import { fetchAPI } from "../../utils/api";
import { Form } from "../form/Form";
import { InvoiceTable } from "./InvoiceTable";
import { Invoice } from "../interfaces/Invoice";
import {asRelevantRole, canMarkInvoiceAsPaidOperator, canMarkInvoiceAsPaidProducer} from "./InvoiceHelper";
import { Role } from "../interfaces/Role";
import useAuth from "../../providers/authProvider";
import { Snackbar } from "@material-ui/core";
import Alert from '@mui/material/Alert';


export default function InvoiceTab() {
    const dispatch = useDispatch();
    const {role}  = useAuth();
    const userRole = role as Role;
    const [status, setStatus] = useState([] as any);
    const [type, setType] = useState([] as any);
    const [resultInvoices, setResultInvoices] = useState([] as Invoice[]);
    const [formState, setFormState] = useState({} as any);
    const [error, setError] = useState('')
    const [open, setOpen] = useState(false)

    useEffect(() => {
        fetchAPI("/invoices/statuses/STATUS")
            .then((res) => res.json())
            .then(setStatus);
        fetchAPI("/invoices/statuses/TYPE")
            .then((res) => res.json())
            .then(setType);
    }, []);

    function search(form: any, page: number = 0) {
        setFormState(form);
        fetchAPI(`/invoices/search?page=${page}&size=15`, {
            method: "POST",
            body: JSON.stringify(form)
        })
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    const response = res.json()
                    return response
                }
                dispatch(hiddenLoader());
                return res;
            })
            .then(data => {
                setResultInvoices(data.content)});
    }

    async function updateAsPaidProducer(invoice : Invoice, callback: () => void ) {

        if(canMarkInvoiceAsPaidProducer(userRole,invoice)){
            fetchAPI(`/invoices/pay/producer`, {
            method: "POST",
            body: 
                JSON.stringify({
                    'producer_id' : invoice.producer_uid,
                    'invoice_id' : invoice.id
                })
            }).then((res) => {
                callback();
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    search(formState, 0)
                }else{
                    return Promise.reject(res);
                }
            }).catch((e) => {
                callback();
                e.text().then((message :any) => {
                    setError(message)})
                    setOpen(true)
            })
        }
    }

    async function updateAsPaidOperator(invoice : Invoice, callback: () => void ) {

        if(canMarkInvoiceAsPaidOperator(userRole,invoice)){
            fetchAPI(`/invoices/pay/operator`, {
                method: "POST",
                body:
                    JSON.stringify({
                        'producer_id' : invoice.producer_uid,
                        'invoice_id' : invoice.id
                    })
            }).then((res) => {
                callback();
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    search(formState, 0)
                }else{
                    return Promise.reject(res);
                }
            }).catch((e) => {
                callback();
                e.text().then((message :any) => {
                    setError(message)})
                setOpen(true)
            })
        }
    }

    function reset() {
        setResultInvoices([])
    }

    let form = {
        "start_date": "datetime",
        "thru_date": "datetime",
        "invoice_id": "string",
        "producer": "string"
    }

    let formHiden = {
        "types": { type: 'multiple', value: type },
        "status": { type: 'multiple', value: status }
    }


    let headers = [
        "currency",
        "edition_date",
        "id",
        "operators",
        "producer_uid",
        "status",
        "total_amount_with_vat",
        "total_amount_without_vat",
        "total_producer_amount",
        "payout_error_log",
        "payout_status",
    ]

    if(asRelevantRole(role)){
        headers.push("mark_as_paid");
    }



    let details = [
        "type",
        "validated",
        "payout",
        "payout_date",
        "operator_payout_date",
        "producer_payout_date",
        "send_date",
        "confirm_date"
    ]

    let clickables = {
        "producer_uid": "/producer?producer="
    }

    return (
        <>
            <Snackbar
                open={open}
                autoHideDuration={4000}>
                    <Alert
                        onClose={() => setOpen(false)}
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                        >
                        {error}
                    </Alert>
            </Snackbar>
            <div className="vtmn-p-4">
                <Form
                    form={form}
                    search={(form: any) => search(form)}
                    formHiden={formHiden}
                    reset={() => reset()}
                />
            </div>
            <div>
                {resultInvoices?.length > 0 
                    ? <InvoiceTable
                        updateAsPaidProducer={(invoice: Invoice, callback: any) => updateAsPaidProducer(invoice, callback)}
                        updateAsPaidOperator={(invoice: Invoice, callback: any ) => updateAsPaidOperator(invoice, callback)}
                        role ={userRole}
                        invoices={resultInvoices}
                        headers={headers}
                        details={details}
                        clickables={clickables}
                        changePage={(page: number) => search(formState, page)}
                        />
                    : <p className="vtmn-text-center">No Result</p>
                }
            </div>
        </>
    )
}
